import React, { useCallback, useEffect, useState } from 'react';
import { Card, Table, Tag } from 'antd';
import Flex from 'components/shared-components/Flex';
import apiClient from 'services/apiClient';
import { useMyContext } from 'Context/MyContextProvider';

const AssignmentHistory = () => {
    const { api, authToken, Permisson, navigate } = useMyContext();
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 20,
        total: 0,
    });

    useEffect(() => {
        if (!Permisson?.includes('View Agent')) {
            navigate('404');
        }
    }, [Permisson, navigate]);

    const fetchHistory = useCallback(async (page = 1, pageSize = 20) => {
        setLoading(true);
        try {
            const response = await apiClient.get(`${api}assignment-history`, {
                params: { page, per_page: pageSize },
                headers: { Authorization: `Bearer ${authToken}` },
            });

            const payload = response.data || {};
            setRows(Array.isArray(payload.data) ? payload.data : []);
            setPagination({
                current: payload.current_page || page,
                pageSize: payload.per_page || pageSize,
                total: payload.total || 0,
            });
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }, [api, authToken]);

    useEffect(() => {
        fetchHistory(1, 20);
    }, [fetchHistory]);

    const eventTypeColor = (eventType) => {
        if (eventType === 'assigned') return 'green';
        if (eventType === 'reassigned') return 'blue';
        if (eventType === 'unassigned') return 'default';
        return 'default';
    };

    const columns = [
        {
            title: 'Date',
            dataIndex: 'created_at_label',
            width: 180,
        },
        {
            title: 'Customer',
            dataIndex: 'customer_display_name',
            render: (_, record) => (
                <div>
                    <div>{record.customer_display_name || record.customer_wa_id}</div>
                    <div className="text-muted" style={{ fontSize: 12 }}>{record.customer_wa_id}</div>
                </div>
            ),
        },
        {
            title: 'Event',
            dataIndex: 'event_type',
            width: 120,
            render: (eventType) => (
                <Tag color={eventTypeColor(eventType)}>
                    {eventType ? eventType.charAt(0).toUpperCase() + eventType.slice(1) : '—'}
                </Tag>
            ),
        },
        {
            title: 'Details',
            dataIndex: 'message_text',
        },
        {
            title: 'Agent',
            dataIndex: 'agent_name',
            width: 140,
            render: (name) => name || '—',
        },
        {
            title: 'Source',
            dataIndex: 'source_label',
            width: 130,
            render: (label) => label || '—',
        },
        {
            title: 'By',
            dataIndex: 'actor_name',
            width: 130,
            render: (name) => name || '—',
        },
    ];

    return (
        <Card bodyStyle={{ padding: 0 }}>
            <div className="container-fluid">
                <Flex justifyContent="space-between" alignItems="center" className="py-4">
                    <h2 className="mb-0">Assignment History</h2>
                </Flex>
            </div>
            <div className="table-responsive">
                <Table
                    loading={loading}
                    columns={columns}
                    dataSource={rows}
                    rowKey="id"
                    pagination={{
                        ...pagination,
                        showSizeChanger: true,
                    }}
                    onChange={(nextPagination) => {
                        fetchHistory(nextPagination.current, nextPagination.pageSize);
                    }}
                />
            </div>
        </Card>
    );
};

export default AssignmentHistory;
